const RANGES = [
  { label: '1h',  hours: 1 },
  { label: '12h', hours: 12 },
  { label: '1j',  hours: 24 },
  { label: '3j',  hours: 72 },
  { label: '7j',  hours: 168 },
  { label: '14j', hours: 336 },
  { label: '30j', hours: 720 },
];

function TimeRangeSelector({ value, onChange }) {
  return (
    <div style={{
      display:        'flex',
      alignItems:     'center',
      gap:            2,
      background:     '#f1f5f9',
      borderRadius:   'var(--radius-md)',
      padding:        3,
    }}>
      {RANGES.map(range => (
        <button
          key={range.hours}
          onClick={() => onChange(range.hours)}
          style={{
            padding:      '4px 10px',
            borderRadius: 'var(--radius-sm)',
            fontSize:     '0.75rem',
            fontWeight:   value === range.hours ? 700 : 500,
            color:        value === range.hours ? 'var(--text)' : 'var(--text-muted)',
            background:   value === range.hours ? 'white' : 'transparent',
            border:       'none',
            cursor:       'pointer',
            boxShadow:    value === range.hours ? 'var(--shadow-xs)' : 'none',
            transition:   'all 0.15s ease',
          }}
        >
          {range.label}
        </button>
      ))}
    </div>
  );
}

export default TimeRangeSelector;
